// src/components/alert/HitsInfo.tsx

import { Alert, Box, Typography } from '@mui/material'

import { HStack } from '..'
import { ServiceName, useServiceName } from '../../hooks/useServiceName'

type HitsInfoProps = {
  count: number
  filter: string
}

export const HitsInfo = ({ count, filter }: HitsInfoProps) => {
  const service: ServiceName = useServiceName()

  return (
    <Alert severity={'info'} sx={{ mx: 1, width: 1 }}>
      <HStack justifyContent={'space-between'}>
        <Typography>
          <Box component={'span'} fontWeight={'bold'}>
            {count}
          </Box>{' '}
          {service} entsprechen dem Suchfilter &quot;
          <Box component={'span'} fontWeight={'bold'}>
            {filter}
          </Box>
          &quot;{' '}
        </Typography>
      </HStack>
    </Alert>
  )
}
